import { useState } from "react";
import { AuthLayout, Notice } from "../components";
import { useRouter } from "../router";
import { useSession } from "../session";

export function SelectOrg() {
  const { me, chooseTenant } = useSession();
  const { navigate } = useRouter();
  const [error, setError] = useState<string | null>(null);
  if (!me) { navigate("/login", true); return null; }
  return (
    <AuthLayout title="Choose an organisation" subtitle="You have access to more than one clinic or hospital.">
      {error && <Notice tone="error">{error}</Notice>}
      <ul className="org-list">
        {me.platformStaff && <li><button className="org-choice" onClick={() => navigate("/platform")}>HealthOS platform console</button></li>}
        {me.memberships.map((m) => (
          <li key={m.tenantId}>
            <button className="org-choice" onClick={async () => { try { await chooseTenant(m.tenantId); navigate("/app", true); } catch (e) { setError((e as Error).message); } }}>
              {m.name}
            </button>
          </li>
        ))}
      </ul>
    </AuthLayout>
  );
}
